module.exports = __webpack_public_path__ + "img/logo_front_new.db38c549.png";